/**
 * 登录页
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import BackGround from './components/BackGround';
import LoginBox from './components/LoginBox';
import { Button, Modal } from 'antd';

class Login extends React.Component {
    render() {
        const type = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
        return (
            <div className={styles.container}>
                <BackGround accountType={type} />
                <LoginBox history={this.props.history} accountType={type} />

                {/* <Modal title="温馨提示" visible={true} centered closable={false} footer={null} maskClosable={false} bodyStyle={{padding: '50px 30px 80px 30px'}}>
                    <p style={{fontSize: '16px'}}>春节期间，系统升级中...</p>
                </Modal> */}
            </div>
        );
    }
}

Login.propTypes = {
    history: PropTypes.object
};

export default Login;